import React from 'react'
import PropTypes from 'prop-types'
import Button from 'components/UI/Button'

import './modal-mobile-header.pcss'

class ModalMobileHeader extends React.PureComponent {
    render () {
        const {
            requireUserInput,
            buttons,
            onClose,
        } = this.props

        return (
            <div className="modal-mobile-header">
                {!requireUserInput && (
                    <div>
                        <Button
                            trackName="closeModal"
                            className="modal-mobile-header__close-button"
                            onClick={onClose}
                        >
                            <span />
                        </Button>
                    </div>
                )}
                <div className="modal-mobile-header__buttons-container">
                    <div className="modal-mobile-header__buttons" id="mobile-modal-buttons">
                        {buttons}
                    </div>
                </div>
            </div>
        )
    }
}

ModalMobileHeader.propTypes = {
    requireUserInput: PropTypes.bool.isRequired,
    buttons: PropTypes.node.isRequired,
    onClose: PropTypes.func.isRequired,
}

export default ModalMobileHeader
